export const OLDAPI = 'http://apienv.mnkfhjwxsz.eu-west-2.elasticbeanstalk.com/';

// export const serverUrl = 'http://nuthub.local/';
export const serverUrl = 'https://nutportal.com/';

// export const APIURL = 'http://nuthub.local/';
export const APIURL = 'https://nutportal.com/';
export const postCheckout = 'api/v1/payments/post-payment';
export const paymentUrl = 'api/v1/payments/has-payment';